import { Button, Result } from "antd";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchDataFromGoogleAuthCode } from "../api/auth.api";
import Loader from "../Layout/Loader";

const GoogleAuthVerified = () => {
  const [searchParams] = useSearchParams();
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  useEffect(() => {
    setCode(searchParams.get("code"));
  }, [searchParams]);

  useEffect(() => {
    if (code?.length > 0) {
      fetchDataFromGoogleAuthCode({ code: code }).then((res) => {
        if (res?.token) {
          toast.success("Logged in successfully!");
          localStorage.setItem("token", res?.token);
          localStorage.setItem("authenticated", true);
          window.location.href = `/app/project/project-list`;
        } else {
          setError(true);
          if (res != null) {
            setErrorMsg(
              "Account with this email does not exist. Please try again with different email."
            );
          } else {
            setErrorMsg(
              "We encountered some error please try logging in again."
            );
          }
        }
      });
    }
  }, [code]);

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        height: "100vh",
      }}
    >
      {code?.length > 0 && <Loader />}

      {error && (
        <Result
          status="403"
          title={errorMsg}
          extra={
            <Button
              type="primary"
              key="console"
              onClick={() => {
                window.location.href = `/login`;
              }}
            >
              Go Back
            </Button>
          }
        />
      )}
    </div>
  );
};

export default GoogleAuthVerified;
